import { z as bind_props } from "./index2.js";
function Editor($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { value = void 0 } = $$props;
    $$renderer2.push(`<div class="form-control"><div id="editorjs"></div></div>`);
    bind_props($$props, { value });
  });
}
export {
  Editor as E
};
